import Menu from "./Menu";
import beef from "../../assets/images/grilled-beef-steak.jpg";
import mittagskarte from "../../assets/images/mittagskarte.jpeg";
import weinkarte from "../../assets/images/wine.jpg";
import "../fonts/schnoerkel.css";

export default function Menus() {
    return (
        <div className="overflow-hidden bg-white py-16 mt-64" id="speisekarten">
            <h1 className="text-center customFont text-4xl md:text-6xl mb-8 text-black">
                Unsere Speisekarten
            </h1>
            <div className="flex flex-col lg:flex-row justify-center items-center gap-8">
                <Menu
                    route="karte?Speisekarte"
                    image={beef}
                    text="SPEISEKARTE"
                />
                <Menu
                    route="/karte?Mittagskarte"
                    image={mittagskarte}
                    text="MITTAGSKARTE"
                />
                <Menu
                    route="/karte?Weinkarte"
                    image={weinkarte}
                    text="WEINKARTE"
                />
                <Menu
                    route="/bestellen"
                    image={mittagskarte}
                    text="BESTELLKARTE"
                />
            </div>
            {/* Button for pdf download */}
        </div>
    );
}
